/**
 * Shared class strings for the host-facing surface (#1029).
 *
 * Kalle's review of the results page (2026-08-20): "näyttää sekamelskalta eri tyylejä" —
 * primary buttons existed in six variants, cards in two border tones, kickers with ad-hoc
 * tracking. One system, three button roles, two sizes; a card base; a kicker. Use THESE in
 * host-surface components (cadence flows, deck, align tab) instead of retyping classes.
 * The summary-block chalkboard system (ChalkboardLabel/Body) is its own canon — not this.
 *
 * Written light-first with `dark:` variants (#918 strip): the reading page is light paper
 * like the host homes, while the older dark host page keeps exactly the look it had. The
 * `dark` class on <html> decides, so a component using these tokens needs no mode prop.
 */

/** Filled emerald CTA — the one action a screen most wants. Same on both surfaces. */
export const btnPrimary =
    'rounded-lg bg-emerald-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-emerald-500 disabled:opacity-50';
/** Large variant for presentation-sized surfaces (deck slides, doorway, banner). */
export const btnPrimaryLg =
    'rounded-lg bg-emerald-600 px-5 py-3 text-sm font-semibold text-white transition hover:bg-emerald-500 disabled:opacity-50';

/** Emerald outline — a real alternative next to a primary. */
export const btnSecondary =
    'rounded-lg border border-emerald-600/60 px-4 py-2 text-sm font-medium text-emerald-700 transition hover:bg-emerald-600/10 disabled:opacity-50 dark:text-emerald-200 dark:hover:bg-emerald-900/30';
export const btnSecondaryLg =
    'rounded-lg border border-emerald-600/60 px-5 py-3 text-sm font-medium text-emerald-700 transition hover:bg-emerald-600/10 disabled:opacity-50 dark:text-emerald-200 dark:hover:bg-emerald-900/30';

/** Neutral outline — de-emphasized choices beside stronger ones. */
export const btnTertiary =
    'rounded-lg border border-stone-300 px-4 py-2 text-sm font-medium text-stone-700 transition hover:border-stone-400 disabled:opacity-50 dark:border-slate-600 dark:text-slate-200 dark:hover:border-slate-400';
export const btnTertiaryLg =
    'rounded-lg border border-stone-300 px-5 py-3 text-sm font-medium text-stone-700 transition hover:border-stone-400 disabled:opacity-50 dark:border-slate-600 dark:text-slate-200 dark:hover:border-slate-400';

/** Quiet inline action rendered as text, not a button shape. */
export const btnLink =
    'text-xs text-stone-500 underline decoration-dotted underline-offset-4 transition hover:text-stone-700 dark:text-slate-400 dark:hover:text-slate-200';

/** Standard content card on the host surface. */
export const cardBase =
    'rounded-lg border border-stone-200 bg-white/85 p-5 dark:border-slate-700 dark:bg-slate-900/40';

/** Section kicker: small uppercase label above a heading. */
export const kicker = 'text-xs font-semibold uppercase tracking-[0.2em] text-stone-500 dark:text-slate-500';
